/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TransitType {
  None = 0,
  T1 = 1,
  T2 = 2,
  T2L = 3,
  T2LF = 4,
}
